import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import { AppButton } from 'components';
import ESTDropDown from 'components/molecules/ESTDropDown';
import ESDropDown from 'components/molecules/ESDropDown';
import ESClassDropDown from 'components/molecules/ESClassDropDown';
import StreamsDropDown from 'components/molecules/StreamsDropDownType';
import CoursesMultiSelect from 'components/molecules/CoursesMultiSelect';
import { useState } from 'react';

const SelectCoursesModal = ({ open, onClose, onConfirm }) => {
  const [curriculum, setCurriculum] = useState({});
  const [board, setBoard] = useState({});
  const [stream, setStream] = useState({});
  const [klass, setKlass] = useState({});
  const [courses, setCourses] = useState([]);

  const clearSelection = () => {
    setCurriculum({});
    setBoard({});
    setStream({});
    setKlass({});
    setCourses([]);
  };

  const handleOk = () => {
    if (!curriculum.id || !board.id || !klass.id || courses.length === 0) return;

    onConfirm({
      curriculum,
      board,
      stream,
      class: klass,
      courses,
    });
    clearSelection();
    onClose();
  };

  return (
    <AppModal open={open} closeModal={onClose} size="lg">
      <AppModalHeader>
        <h5 className="modal-sub-text">Select Courses</h5>
        <button className="btn-close" onClick={onClose} />
      </AppModalHeader>

      <AppModalBody>
        <ESTDropDown
          enableAPI
          value={curriculum.id}
          handleChange={(e) =>
            setCurriculum({
              id: e.target.value,
              name: e.target.options[e.target.selectedIndex].text,
            })
          }
          label="Curriculum"
        />

        <ESDropDown
          enableAPI={!!curriculum.id}
          dependencies={{ query: `est=${curriculum.id}` }}
          value={board.id}
          handleChange={(e, args) =>
            setBoard({
              id: e.target.value,
              name: e.target.options[e.target.selectedIndex].text || '',
            })
          }
          label="Board"
        />

        <StreamsDropDown
          enableAPI
          value={stream.id}
          handleChange={(e, args) =>
            setStream({
              id: e.target.value,
              name: e.target.options[e.target.selectedIndex].text || '',
            })
          }
          label="Stream"
        />

        <ESClassDropDown
          enableAPI={!!board.id}
          dependencies={{ query: `esId=${board.id}` }}
          value={klass.id}
          handleChange={(e, args) =>
            setKlass({
              id: e.target.value,
              name: e.target.options[e.target.selectedIndex].text || '',
            })
          }
          label="Class"
        />

        <CoursesMultiSelect
          enableAPI={!!klass.id}
          values={courses}
          handleChange={setCourses}
          dependencies={{
            query: { estId: curriculum.id, esId: board.id, classId: klass.id },
          }}
        />
      </AppModalBody>

      <AppModalFooter classNames="mt-4 d-flex justify-content-end">
        <AppButton variantClass="btn-primary" onClick={handleOk}>
          OK
        </AppButton>
      </AppModalFooter>
    </AppModal>
  );
};

export default SelectCoursesModal;
